import Image from 'next/image';
import React from 'react';

import { ScrollChevron } from './store/Store';

export interface ScrollTagCmpProps
  extends React.HTMLAttributes<HTMLDivElement> {
  text?: string;
  direction: 'down' | 'up';
}

const ScrollTagCmp: React.FC<ScrollTagCmpProps> = ({
  text = 'SCROLL',
  direction = 'down',
  ...props
}) => {
  const arrow = React.useMemo(
    () => (
      <Image
        src={ScrollChevron.src}
        alt={ScrollChevron.alt}
        width={12}
        height={12}
        className={`${
          direction === 'up' ? 'rotate-180' : ''
        } transition-transform duration-300 ease-in-out`}
      />
    ),
    [direction],
  );

  return (
    <div
      {...props}
      className={`select-none cursor-default flex items-center justify-center gap-[0.4rem] p-[0.4rem_0.6rem] rounded-[100rem] bg-[#374962] shadow-[0rem_0.2rem_0.4rem_0rem_#3749620F] ${props.className}`}
    >
      {arrow}
      <div className={`text-[1rem] font-bold leading-[1.2rem] text-[#CBD5E1]`}>
        {text}
      </div>
      {arrow}
    </div>
  );
};

export default ScrollTagCmp;
